module.exports = __webpack_public_path__ + "static/media/joblist-be.b344c8af.png";